"use client";

import _objectWithoutProperties from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["all"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { findExecutor, findExecutors, mergeExecutors } from "./chunk-LGLUH4PH.js";

// src/client.tsx
import { createContext, useContext, useEffect, useState } from "react";
import { Fragment, jsx } from "react/jsx-runtime";
var ExecutorsContext = createContext({
  executors: []
});
var OperationExecutorsProvider = function OperationExecutorsProvider(_ref) {
  var children = _ref.children,
    executors = _ref.executors;
  var upstream = useContext(ExecutorsContext).executors;
  var merged = mergeExecutors(upstream, executors);
  return /* @__PURE__ */jsx(ExecutorsContext.Provider, {
    value: {
      executors: merged
    },
    children: children
  });
};
var useOperationExecutor = function useOperationExecutor(id, variables) {
  var _useContext = useContext(ExecutorsContext),
    executors = _useContext.executors;
  return findExecutor(executors, id, variables);
};
var useAllOperationExecutors = function useAllOperationExecutors(id, variables) {
  var _useContext2 = useContext(ExecutorsContext),
    executors = _useContext2.executors;
  return findExecutors(executors, id, variables);
};
function DelayedOperation(_ref2) {
  var children = _ref2.children,
    operation = _ref2.operation;
  var _useState = useState("loading"),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var _useState3 = useState(void 0),
    _useState4 = _slicedToArray(_useState3, 2),
    data = _useState4[0],
    setData = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];
  useEffect(function () {
    setState("loading");
    operation().then(function (result) {
      setData(result);
      setState("success");
      return;
    }).catch(function (error2) {
      setError(error2);
      setState("error");
    });
  }, [operation, setData, setError, setState]);
  return /* @__PURE__ */jsx(Fragment, {
    children: children({
      state: state,
      error: error,
      data: data
    })
  });
}
function SingleOperation(props) {
  var registry = useContext(ExecutorsContext).executors;
  var executor = findExecutor(registry, props.id, props.variables);
  if (!(executor instanceof Function)) {
    return props.children({
      state: "success",
      data: executor
    });
  }
  return /* @__PURE__ */jsx(DelayedOperation, _objectSpread(_objectSpread({}, props), {}, {
    operation: function operation() {
      return executor(props.id, props.variables);
    }
  }));
}
function MultiOperation(props) {
  var registry = useContext(ExecutorsContext).executors;
  var executors = findExecutors(registry, props.id, props.variables);
  if (executors.every(function (exec) {
    return !(exec instanceof Function);
  })) {
    return props.children({
      state: "success",
      data: executors
    });
  }
  return /* @__PURE__ */jsx(DelayedOperation, _objectSpread(_objectSpread({}, props), {}, {
    operation: function operation() {
      return Promise.all(executors.map(function (exec) {
        return exec instanceof Function ? exec(props.id, props.variables) : exec;
      }));
    }
  }));
}
var Operation = function Operation(_ref3) {
  var all = _ref3.all,
    props = _objectWithoutProperties(_ref3, _excluded);
  return all ? /* @__PURE__ */jsx(MultiOperation, _objectSpread({}, props)) : /* @__PURE__ */jsx(SingleOperation, _objectSpread({}, props));
};
export { Operation, OperationExecutorsProvider, findExecutor, findExecutors, useAllOperationExecutors, useOperationExecutor };